import React from 'react';
import ReactDOM from 'react-dom/client';
import { Provider } from 'react-redux';
import App from './App';
import './index.css';
import store from './store/store';
import 'bootstrap/dist/css/bootstrap.min.css';
import 'primereact/resources/primereact.min.css';
import 'primereact/resources/themes/saga-blue/theme.css';
import 'react-circular-progressbar/dist/styles.css';

// Remove any other locatorjs-related code or error suppression blocks as well
if (process.env.NODE_ENV === 'production') {
  window.addEventListener(
    'error',
    function (event) {
      if (event.message && (event.message.includes('[locatorjs]') || event.message.includes('[locator-js]'))) {
        event.preventDefault();
        return true; // Prevents the error from being logged
      }
      return false; // Let other errors propagate normally
    },
    true,
  );
}

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <Provider store={store}>
    <App />
  </Provider>,
);
